<template>
    <div class="loader"></div>
</template>

<script>

export default {
    name: "Loader",
}
</script>

<style lang="scss" scoped>

    @import "../../assets/styles/_globals";

    .loader {
        border: 10px solid $prim_bg_color; /* Light grey */
        border-top: 10px solid $seltec_color; /* Blue */
        border-radius: 50%;
        width: 40px;
        height: 40px;
        animation: spin 2s linear infinite;
    }

    @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
    }

</style>